<template>
  <div class="reportingbox" title="举报须知">
    <h3>感谢您对科研诚信建设的关心和支持!贯彻、落实中办、国办《关于进一步加强科研诚信建设的若干意见》《关于进一步弘扬科学家精神加强作风和学风建设的意见》是我们共同的责任。欢迎您进行负责任的举报，举报前请认真阅读以下内容:</h3>
    <h3>一 、受理范围:</h3>
    <p>在项目的申请、评审、实施、结题和成果发表与应用等活动中发生的科研不端行为，具体包括</p>
    <p>(一)抄袭、剽窃、侵占;</p>
    <p>(二)伪造、篡改;</p>
    <p>(三) 买卖、代写;</p>
    <p>(四)提供虚假信息、隐瞒相关信息以及提供信息不准确;</p>
    <p>(五)通过贿赂或者利益交换等不正当方式获取科学基金项目;</p>
    <p>(六)违反科研成果的发表规范、署名规范、引用规范;</p>
    <p>(七)违反评审行为规范;</p>
    <p>(八)违反科研伦理规范;</p>
    <p>(九)违反国家自然科学基金项目资金使用规范;</p>
    <p>(十)其他科研不端行为;</p>
    <h3>二、不予受理范围:</h3>
    <p>(一)与xxx无关的举报,包括但不限于xxxxxx等;</p>
    <p>(二)举报内容不属于科研不端行为的;</p>
    <p>(三)没有明确的证据和可查线索的;</p>
    <p>(四)对同一对象重复举报且无新的证据、线索的;</p>
    <p>(五)已经做出生效处理决定且无新的证据、线索的;</p>
    <h3>三、举报人应对举报事实的真实性负责，如有诬陷、制造假证等行为，须承担相应的法律法规和纪律责任。四、提倡实名举报(请提供有效身份信息和准确联系方式)。:</h3>
    <p style="color:red">请注意:涉及国家秘密的举报，请勿通过本网站提交。</p>
    <el-checkbox v-model="checked">我已阅读并同意以上条款</el-checkbox>
     <!-- <el-divider></el-divider> -->
     <br>
    <div class="jc-c">
        <div type="primary" @click="realname" class="real-name">
            <img src="../../../assets/img/themes/real-name.png" alt="">
            实名举报
        </div>
    <div type="warning" @click="anonymous " class="anonymous">
        <img src="../../../assets/img/themes/anonymous.png" alt="">
        匿名举报
    </div>
    </div>
  </div>
</template>

<script>
export default {
data () {
    return {
        checked: false
    }
},
methods: {
    realname(){
        if(this.checked == false){
            this.$message({
          message: '请先阅读以上条款',
          type: 'warning'
        });
        } else {
            this.$router.push(
                {
                    path:"/research-integrity/realname",
                    query:{
                        id:2
                    }
                }
            )
        }
    },
    anonymous(){
        if(this.checked == false){
            this.$message({
          message: '请先阅读以上条款',
          type: 'warning'
        });
        } else {
            this.$router.push(
                {
                    path:"/research-integrity/anonymous",
                    query:{
                        id:2
                    }
                }
            )
        }
    }
}
}
</script>

<style lang="scss" scoped>
body{
    overflow: auto !important;
}
// ::v-deep 
.reportingbox{
    
    width: 1200px;
    margin: 0 auto;
    overflow: auto;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 0 20px;
    border-top: 3px solid #1E8CE6;
    margin-top: 20px;
}
p{
    margin: 0;
    line-height: 28px;
}
.anonymous{
width: 200px;
height: 50px;
background: #FF850C;
display: flex;
align-items: center;
justify-content: center;
color: #FFFFFF;
cursor: pointer;
}
.real-name{
    width: 200px;
height: 50px;
background: #157ED6;
display: flex;
align-items: center;
justify-content: center;
color: #FFFFFF;
margin-right: 20px;
cursor: pointer;
}
</style>